import { render } from "./ListeBoitePostale.vue?vue&type=template&id=19781802&ts=true"
import script from "./ListeBoitePostale.vue?vue&type=script&lang=ts"
export * from "./ListeBoitePostale.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__